import { useQuery } from '@tanstack/react-query';

import Api from '@/services/api';
import { QUERY_KEYS } from '@/utils/query-keys';
import type { AxiosErrorResponse, BaseReportsPaginated, BaseReportsPaginatedResponse, PaginatedData } from '@/types';

export type ListAllAngleTimeDTO = BaseReportsPaginated;

export type ListAllAngleTimeResponse = PaginatedData<BaseReportsPaginatedResponse>;

async function listAngleTimePaginated(params: ListAllAngleTimeDTO): Promise<ListAllAngleTimeResponse> {
	const url = '/ergonomic-tool/angle-time/reports/list-all';
	const { data } = await Api.get<ListAllAngleTimeResponse>(url, {
		params
	});
	return data;
}

export const useListAngleTimePaginated = ({
	limit,
	offset,
	sector_id,
	cellule_id,
	company_id,
	report_name,
	activity_id,
	evaluator_id,
	original_name,
	created_at_end,
	workstation_id,
	organization_id,
	created_at_start,
	isSelectedReport
}: ListAllAngleTimeDTO) => {
	const enabled = !!limit && !!isSelectedReport && offset >= 0;
	const angleTimeReport = useQuery<ListAllAngleTimeResponse, AxiosErrorResponse>(
		[
			QUERY_KEYS.GET_ANGLE_TIME_REPORTS_PAGINATED,
			[
				limit,
				offset,
				sector_id,
				company_id,
				cellule_id,
				report_name,
				activity_id,
				evaluator_id,
				original_name,
				created_at_end,
				workstation_id,
				organization_id,
				created_at_start
			]
		],
		() =>
			listAngleTimePaginated({
				limit,
				offset,
				sector_id,
				company_id,
				cellule_id,
				report_name,
				activity_id,
				evaluator_id,
				original_name,
				created_at_end,
				workstation_id,
				organization_id,
				created_at_start
			}),
		{
			enabled,
			retry: 0
		}
	);
	return angleTimeReport;
};
